import { render, staticRenderFns } from "./SummaryCard.vue?vue&type=template&id=69641842&scoped=true&"
import script from "./SummaryCard.vue?vue&type=script&lang=js&"
export * from "./SummaryCard.vue?vue&type=script&lang=js&"
import style0 from "./SummaryCard.vue?vue&type=style&index=0&id=69641842&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69641842",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\Kevin\\Documents\\source\\locate2u-server\\Locate2u.AppPortal\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('69641842')) {
      api.createRecord('69641842', component.options)
    } else {
      api.reload('69641842', component.options)
    }
    module.hot.accept("./SummaryCard.vue?vue&type=template&id=69641842&scoped=true&", function () {
      api.rerender('69641842', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/Trips/Components/SummaryCard.vue"
export default component.exports